import { makeStyles } from 'tss-react/mui';
import React from 'react';
import { ApiButton, Box, Grid, KeyValue, Pill } from 'web-library';
import { useTranslation } from 'react-i18next';
import IconWithLabel from 'web-library/stories/atom/IconWithLabel/IconWithLabel';
import { IconName } from 'web-library/stories/atom/Icon/Icon';
import { useParams } from 'react-router-dom';
import { AppealTransactionDetailsInSummary } from '../../../../api/candidate/appeal/model';
import FormHeader from '../../../../components/form-items/FormHeader';
import { usePostCoordinatorAppealSendPaymentLink } from '../../../../api-refactored/appeal/usePostCoordinatorAppealPaymentLink';

import {typeTheme} from "web-library/theme/helper/tssHelper"
const useStyles = makeStyles()((theme) =>
({
  container: {
    paddingBottom: theme.spacing(3),
    maxWidth: 960,
  },
  sectionTitle: {
    paddingTop: theme.spacing(2),
    marginBottom: theme.spacing(3),
  },
  [theme.breakpoints.down('md')]: {
    statusPill: {
      marginTop: theme.spacing(1),
    },
  },
  sendEmailButton: {
    color: theme.color.link.linkDefault01,
    padding: 0,
    minWidth: 0,
    height: 0,
    '& p': {
       ...typeTheme(theme, 'buttonMedium'),
    },
  },
}));

const TransactionDetails = ({ ...props }: AppealTransactionDetailsInSummary) => {
  const { classes } = useStyles();
  const { t } = useTranslation();
  const { uuid } = useParams<{ uuid: string }>();

  const {
    mutate: mutatePostCoordinatorAppealSendPaymentLink,
    status: statusPostCoordinatorAppealSendPaymentLink,
  } = usePostCoordinatorAppealSendPaymentLink();

  return (
    <Box className={classes.container}>
      <FormHeader title={t('appeal->>AppealSummary.TransactionDetails.TransactionDetails')} />
      <Grid container>
        <Grid xs={12} sm={6}>
          <KeyValue
            id="referenceNo"
            keyText={t('appeal->>AppealSummary.TransactionDetails.RefNo')}
            valueText={props?.internalTransactionRef || 'N/A'}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid xs={12} sm={6}>
          <KeyValue
            id="transactionNo"
            keyText={t('appeal->>AppealSummary.TransactionDetails.TransactionNo')}
            valueText={props.transactionNumber || 'N/A'}
          />
        </Grid>
      </Grid>
      <Grid container>
        <Grid xs={12} sm={6}>
          <KeyValue
            keyText={t('appeal->>AppealSummary.TransactionDetails.PaymentMethod')}
            valueText={props.paymentMethod}
          />
        </Grid>
        <Grid xs={12} sm={6}>
          <KeyValue
            keyText={t('appeal->>AppealSummary.TransactionDetails.PaymentStatus')}
            valueText={
              <Grid className={classes.statusPill}>
                <Pill
                  label={props.paymentStatus}
                  variant={
                    props.paymentStatus === 'Pending payment' || props.paymentStatus === 'Unpaid'
                      ? 'info'
                      : 'positive'
                  }
                />
                {props.isGroup &&
                  props.paymentStatus === 'Pending payment' &&
                  props.paymentLinkRequired && (
                    <ApiButton
                      variant="text"
                      color="primary"
                      onClick={() => mutatePostCoordinatorAppealSendPaymentLink(uuid)}
                      size="small"
                      status={statusPostCoordinatorAppealSendPaymentLink}
                      className={classes.sendEmailButton}
                    >
                      <IconWithLabel
                        iconName={IconName.email}
                        iconSize="M"
                        label="Send Payment Link"
                      />
                    </ApiButton>
                  )}
              </Grid>
            }
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default TransactionDetails;
